import { PauseIcon, PlayIcon } from "@heroicons/react/24/solid";
import { motion } from "framer-motion";
import Image from "next/image";

import { WaveformBars } from "@/app/(marketing)/components/demo/showcases/conversionShowcase/components/WaveformBars";
import { ShowcaseArtist, ShowcaseSong } from "@/types/defs/conversionShowcase";

export function ConversionShowcaseOutputCardMobile({
  selectedVoice,
  selectedSong,
  isPlaying,
  displayWave,
  activeWave,
  onPlay,
}: {
  selectedVoice: ShowcaseArtist;
  selectedSong: ShowcaseSong;
  isPlaying: boolean;
  displayWave: number[];
  activeWave: boolean;
  onPlay: () => void;
}) {
  return (
    <div className="rounded-2xl bg-gray-100 p-3">
      <div className="flex items-center gap-3">
        <motion.div
          key={selectedVoice.id}
          initial={{ opacity: 0, scale: 0.88 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ type: "spring", stiffness: 320, damping: 24 }}
          className="relative h-11 w-11 shrink-0 overflow-hidden rounded-xl"
        >
          <Image
            src={selectedVoice.image}
            alt={selectedVoice.name}
            fill
            className="object-cover"
          />
        </motion.div>
        <div className="flex flex-1 flex-col">
          <span className="text-sm font-semibold text-gray-900">
            {selectedVoice.name}
          </span>
          <span className="text-xs text-gray-400">{selectedSong.label}</span>
        </div>
        <motion.button
          type="button"
          onClick={onPlay}
          className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-900"
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.92 }}
        >
          {isPlaying ?
            <PauseIcon className="h-4 w-4 text-white" />
          : <PlayIcon className="ml-0.5 h-4 w-4 text-white" />}
        </motion.button>
      </div>
      <div className="mt-2.5 flex h-10 items-center justify-center gap-[2.5px] overflow-hidden">
        <WaveformBars
          data={displayWave}
          active={activeWave}
          barWidth="w-[4px]"
        />
      </div>
    </div>
  );
}
